module.exports = function() {
  return new Worker(__webpack_public_path__ + "18e82ec148b5aec1cdbb.worker.js");
};